import {AsyncImage} from 'components/atoms/Media/AsyncImage';
import {Container} from 'components/atoms/Layout/Container';
import {Headline} from 'components/atoms/Text/Headline';

import {P} from 'components/atoms/Text/P';
import {HeadlineLevel, ParagraphSize} from 'features/ui/enums';
import {Breadcrumbs} from 'components/molecules/NavigationComponents/Breadcrumbs';
import {StructuredData} from 'components/molecules/StructuredData';
import {StructuredDataBreadcrumbs} from 'components/molecules/StructuredDataBreadcrumbs';
import {ContentArea} from 'components/organisms/GeneralComponents/ContentArea';
import {ImageSizes} from 'components/organisms/Shell/image-size-enum';
import * as React from 'react';
import {InspirationPageViewModel} from 'features/template/viewModels/InspirationPage';

import './style.scss';
import {useBreadcrumbs} from "features/template/ViewModelProvider";
import {PageModel} from "features/template/types";
import { useDeviceStore, selectIsMobile } from 'features/ui/store/useDeviceStore';

type Props = PageModel<InspirationPageViewModel>;

export const InspirationPage: React.FunctionComponent<Props> = ({viewModel}) => {

    const isMobile = useDeviceStore(selectIsMobile);
    const breadcrumbs = useBreadcrumbs();

    return (
        <div className="inspiration-page">

            <StructuredDataBreadcrumbs breadcrumbs={breadcrumbs} />
            <StructuredData structuredData={viewModel.structuredData} />

            <Breadcrumbs
                breadcrumbs={breadcrumbs}
                scrollTop
            />
            <div className="inspiration-page__image">
                <AsyncImage
                    image={viewModel.image}
                    quality={ImageSizes.SIZE_2560}
                    fullHeight={isMobile}
                    alt={viewModel.title}
                />
            </div>
            <Container narrow intro className="inspiration-page__text">
                <Headline 
                    level={HeadlineLevel.H1} 
                    className="inspiration-page__title" 
                >
                    {viewModel.title}
                </Headline>

                <P
                    className="inspiration-page__main-body"
                    size={ParagraphSize.L}
                >
                    {viewModel.mainBody}
                </P>
            </Container>

            <ContentArea id="inspiration-page-blocks" blocks={viewModel.contentArea} />
        </div>
    )
};
